import { render, staticRenderFns } from "./ContextMenuItem.vue?vue&type=template&id=f4f06b0c&scoped=true&"
import script from "./ContextMenuItem.vue?vue&type=script&lang=js&"
export * from "./ContextMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenuItem.vue?vue&type=style&index=0&id=f4f06b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f06b0c",
  null
  
)

export default component.exports